<template>
  <svg
    class="pit-svg"
    :fill="color"
    enable-background="new 0 0 384 512"
    version="1.1"
    viewBox="0 0 384 512"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M369.9,97.9L286,14c-9-9-21.2-14.1-33.9-14.1H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h288c26.5,0,48-21.5,48-48  V131.9C384,119.2,378.9,106.9,369.9,97.9z M332.1,128H256V51.9L332.1,128z M48,464V48h160v104c0,13.3,10.7,24,24,24h104v288H48z"
    />
    <path d="M125.7,255.7H102v67.8H83.2v-67.8H59.7v-15.2h66V255.7z" />
    <path d="m186.7 323.6h-49.8v-83.1h47.9v15.2h-29.2v18.5h27.2v15.2h-27.2v19h31.1v15.2z" />
    <path
      d="m196.7 320.4v-18.5c6.6 5.6 14 8.5 22 8.5 3.8 0 6.8-0.8 8.9-2.3 2.1-1.6 3.2-3.6 3.2-6.1 0-2.2-0.9-4.2-2.7-6.1s-6-4.5-12.7-7.6c-12.7-6-19-14.1-19-24.3 0-7.5 2.8-13.4 8.3-17.9s12.9-6.7 22-6.7c8.1 0 14.8 1.1 20.2 3.2v17.3c-5.6-3.9-11.9-5.8-19.1-5.8-3.6 0-6.4 0.8-8.5 2.3s-3.1 3.6-3.1 6.1 0.8 4.6 2.5 6.3c1.6 1.7 5.1 3.9 10.4 6.4 8.2 3.9 13.8 7.8 16.9 11.6 3.1 3.9 4.6 8.4 4.6 13.7 0 7.6-2.8 13.7-8.3 18.1s-13.5 6.7-24 6.7c-8.7-0.3-15.9-1.8-21.6-4.9z"
    />
    <path d="M322,255.7h-23.7v67.8h-18.8v-67.8H256v-15.2h66V255.7z" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000',
    },
  },
}
</script>

<style lang="scss" scoped>
.pit-svg {
  height: 20px;
  overflow: hidden;
}
</style>
